import { SwaggerConfig } from './swagger.interface';

/**
 * Configuration for the swagger UI (found at /api).
 * Change this to suit your app!
 */
export const SWAGGER_CONFIG: SwaggerConfig = {
  title: 'BOI-PARIKSHIT',
  description: 'Services for BOI-PARIKSHIT',
  version: '1.0',
  tags: ['BOI-PARIKSHIT,AI BASED PAPERS GENERATOR'],
};
